import SocialCard from "./SocialCard";
import { DiscardedPostType } from "../types";
import { getTrueDate } from "@/lib/utils";

type EventListProps = {
  socialData: DiscardedPostType,
  event_status: "Scheduled" | "Pending",
  name: string;
}

const EventList = ({ socialData, event_status, name }: EventListProps) => {
  return (
    <>
      <div id={name} className={`w-full flex-col gap-3 shadow-md px-4 py-3 ${( socialData.post_type === "Campaign" || socialData.post_type === "campaign" ) ? "bg-campaign-light/50" : "bg-post-light/50"} rounded-xl text-sm text-gray-600`}>
        <div className="flex-col md:flex-row w-full flex md:items-center justify-between">
          <div className="flex items-center gap-3 w-full">
            <div className="w-[20%] md:w-[5%] 2xl:w-[4%] rounded-md border bg-black text-white border-gray-200 aspect-square flex flex-col items-center justify-center">
              <p className="text-xs">{getTrueDate(socialData.start_date, "MMM")}</p>
              <p className="text-sm font-semibold">{getTrueDate(socialData.start_date, "d")}</p>
            </div>
            {socialData.post_type === "Campaign" && (<><p>-</p>
            <div className="w-[20%] md:w-[5%] 2xl:w-[4%] rounded-md border bg-black text-white border-gray-200 aspect-square flex flex-col items-center justify-center">
              <p className="text-xs">{getTrueDate(socialData.end_date, "MMM")}</p>
              <p className="text-base font-semibold">{getTrueDate(socialData.end_date, "d")}</p>
            </div></>)}
            <div id="info" className="flex flex-col">
              <div className="flex flex-col md:flex-row md:gap-3 items-center">
                <p className="font-montserrat text-black ps-3 font-semibold text-lg">{socialData.event}</p>
              </div>
              {socialData.post_type === "Campaign" && <p className="text-xs">{socialData.content.length} posts remaining for approval</p>}
            </div>
          </div>

        </div>
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {socialData.content.map((content, index) => (
          <SocialCard key={index}
            content={content}
            event_id={socialData.event_id}
            event_name={socialData.event}
            event_status={event_status}
          />
        ))}
      </div>

    </>
  )
}

export default EventList;
